import { render } from "./SimpleInput.vue?vue&type=template&id=651dc4d2&scoped=true&ts=true"
import script from "./SimpleInput.vue?vue&type=script&lang=ts"
export * from "./SimpleInput.vue?vue&type=script&lang=ts"

import "./SimpleInput.vue?vue&type=style&index=0&id=651dc4d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651dc4d2"]])

export default __exports__